import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Image} from '@udemy/react-core-components';
import {Modal} from '@udemy/react-dialog-components';

import styles from './personal-plan-banner-modal.module.less';

interface ValuePlanBannerModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ValueProp = ({headline, text}: {headline: string; text: string}) => {
    return (
        <div className={styles.prop}>
            <div className="ud-heading-lg">{headline}</div>
            <div className="ud-text-lg">{text}</div>
        </div>
    );
};

export const ValuePlanBannerModal: React.FC<ValuePlanBannerModalProps> = ({isOpen, onClose}) => {
    const {gettext} = useI18n();

    const valuePlanValueProps = [
        {
            headline: gettext('Essential skills'),
            text: gettext(
                'Focus on high-impact topics with a curated set of courses picked to help you build momentum quickly.',
            ),
        },
        {
            headline: gettext('Great value'),
            text: gettext(
                'Get reliable access to quality learning at a plan built for learners who want strong outcomes without the full catalog.',
            ),
        },
        {
            headline: gettext('Room to grow'),
            text: gettext(
                'When you are ready for more, you can explore options to expand your access and go deeper.',
            ),
        },
    ];

    return (
        <Modal title="" isOpen={isOpen} onClose={onClose} className={styles['banner-modal']}>
            <h1 className="ud-heading-serif-xxl">{gettext('Udemy Value Plan')}</h1>
            <p className={classNames('ud-text-lg', styles.message)}>
                {gettext(
                    'Your Value Plan includes a curated collection of courses to help you build skills that matter. Here is what you get:',
                )}
            </p>
            <Image
                alt=""
                className={styles.prop}
                width={120}
                height={120}
                src="https://s.udemycdn.com/teaching/value-prop-teach-v3.jpg"
                srcSet={`https://s.udemycdn.com/teaching/value-prop-teach-v3.jpg 1x, https://s.udemycdn.com/teaching/value-prop-teach-2x-v3.jpg 2x`}
            />
            {valuePlanValueProps.map((prop, index) => (
                <ValueProp key={index} headline={prop.headline} text={prop.text} />
            ))}
        </Modal>
    );
};
